export const propertyViewsSelector = (state) => ({ propertyViews: state.propertyViews });
